const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { findIndex, filter } = require('lodash');

// @ helpers
const { formatText } = require('core/i18n').i18n;

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');

// @ components
const { MortgageRequestDocumentationCenterItem } = require('./mortgageRequestDocumentationCenterItem');
const { OKLink } = require('commonsComponents/OKLink');

// @ constants
const documentsTypes = require('constants/mortgageRequestDocumentsTypes');

class MortgageRequestDocumentationCenterLean extends React.Component {
    constructor(props) {
        super(props);
        this.buildLeanListItem = this.buildLeanListItem.bind(this);
    }

    buildLeanListItem(idDocumentType, idDocumentNumber) {
        return (dataLeanItem, index) => {
            let centerItem = '';
            const documentType = dataLeanItem.documentType;
            const isMFH = documentType === documentsTypes.MANIFESTACION_FIRMADA_HIPO;
            const itemIdDocumentType = isMFH ? dataLeanItem.idDocumentType : idDocumentType;
            const itemIdDocumentNumber = isMFH ? dataLeanItem.idDocumentNumber : idDocumentNumber;
            if (dataLeanItem) {
                centerItem = (
                    <MortgageRequestDocumentationCenterItem
                        key={index}
                        documentType={documentType}
                        documentTypeLabel={dataLeanItem.documentTypeLabel}
                        documentStatus={dataLeanItem.documentStatus}
                        documentEstateId={dataLeanItem.documentEstateId}
                        idDocumentType={itemIdDocumentType}
                        idDocumentNumber={itemIdDocumentNumber}
                    />
                );
            }
            return centerItem;
        }
    }

    moveFIPREBeforeFIPER(documents = []) {
        const insert = (item, array, position) => {
            const clone = [...array];
            clone.splice(position, 0, item)
            return clone;
        }
        const fiperIndex = findIndex(documents, document => document.documentType === documentsTypes.FIPER);
        const fipreIndex = findIndex(documents, document => document.documentType === documentsTypes.FIPRE);
        const fipreItem = documents[fipreIndex];
        let newDocuments = filter(documents, document => document.documentType !== documentsTypes.FIPRE);
        newDocuments = insert(fipreItem, newDocuments, fiperIndex);

        return newDocuments;
    }

    goBack() {
        this.props.history.goBack();
    }

    render() {
        const { lean } = this.props;
        const leanListItem = lean.documents.map(
            this.buildLeanListItem(lean.idDocumentType, lean.idDocumentNumber)
        );

        return (
            <ContentBox
                title={formatText('mortgageRequestDocumentationCenter-subtitleSectionLean')}
                smallTitle={true}
                titleSeparator={true}
                customClassName="mortgage-request-documentation-center__section"
            >
                <ul className="list-unstyled mortgage-request-documentation-center__list">
                    {leanListItem}
                </ul>

                <div className="row">
                    <div className="col-md-10 mortgage-request-holder-information__margin-button">
                        <OKLink
                            modifier="emphasize"
                            name={'btnDocuments'}
                            onClick={() => this.goBack()}
                        >
                            {formatText('mortgageRequestHolderInformation-returnLink')}
                        </OKLink>
                    </div>
                </div>
            </ContentBox>
        );
    }
}

MortgageRequestDocumentationCenterLean.propTypes = {
    history: PropTypes.object.isRequired,
    lean: PropTypes.object
}

module.exports = withRouter(MortgageRequestDocumentationCenterLean);
